import { Flex } from "@chakra-ui/react";
import React from "react";
import { GenericError } from "src/components/Feedback/GenericError";
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  TabsWithHash,
} from "src/components/Layout/TabsWithHash";
import { ContentTab } from "src/scenes/orgAdmin/formTemplates/ContentTab/ContentTab";
import { FORM_TEMPLATE_TAB_HASH } from "src/services/url/OrgAdmin";
import * as GQL from "src/types/graphql";

type ViewProps = {
  formTemplate: GQL.EditFormTemplateFragment;
};
export const View: React.FC<ViewProps> = (props) => {
  const { formTemplate } = props;

  if (formTemplate.schema_version === "1.0.0") {
    return <GenericError message="View page is not supported for v1.0." />;
  }

  return (
    <Flex direction="column" grow="1" minHeight="100%">
      <TabsWithHash variant="admin" isLazy>
        <TabList>
          <Tab hashKey={FORM_TEMPLATE_TAB_HASH.CONTENT}>Content</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ContentTab />
          </TabPanel>
        </TabPanels>
      </TabsWithHash>
    </Flex>
  );
};
